/* eslint-disable no-unused-vars */
export default {
    bind(el, binding, vnode) {
        // console.log('bind');
    },
    inserted(el, binding, vndoe) {
        // console.log('inserted');
    },
    updated(el, binding, vnode) {
        // console.log('updated');
    },
    componentUpdated(el, binding, vnode, oldVnode) {
        // console.log('componentUpdated');
    },
};



// WEBPACK FOOTER //
// ./src/directives/custom.js